<div class="creative-graph">
    <div></div>
    <div id="custom-legend" *ngIf="enableCustomLegend && customLegendData">
        <ngu-carousel #carousel (initData)="initDataFn($event)" [inputs]="carouselOne" [dataSource]="customLegendData">
            <ngu-tile *nguCarouselDef="let legend;let index=index;" NguCarouselItem>
                <div class="legend-circle" [ngStyle]="{'background-color': legend?.color}"
                    [ngClass]="{'inactive': !legend?.active}" (click)="updateLegendArray(legend, index)"></div>
                <div class="custom-legend-item" (click)="updateLegendArray(legend, index)"
                    [ngClass]="{'inactive': !legend?.active}" title={{legend?.name}}>{{legend?.name}}</div>
            </ngu-tile>

            <span NguCarouselPrev class="leftRs">
                <i class="fa fa-angle-left" aria-hidden="true"></i>
            </span>
            <span NguCarouselNext class="rightRs">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </ngu-carousel>
    </div>
    <div class="wrapper">
        <div class="legend-area" *ngIf="!legendDisabled">
            <div class="legend1">
                <div class="legend_item primary-color-border" [ngStyle]="{'background-color': getColors(i)}"
                    [ngClass]="{'inactivebg': !legendItem?.active}" (click)="updateLegends(legendItem, i)"
                    *ngFor="let legendItem of legendData; let i = index">
                    {{legendItem.displayName}}
                </div>
            </div>
        </div>
        <div id="graph-area" class="graph-area" #graphArea></div>
    </div>
</div>